import type { ServersService } from './services/servers';

export const MAGICNOTES_SERVER_URL = 'https://magicnotes.top';
export const MAGICNOTES_SERVER_NAME = 'magicnotes.top';

export function findMagicNotesServer(serversService: ServersService) {
  return serversService.servers$.value.find(
    server => server.baseUrl.replace(/\/$/, '') === MAGICNOTES_SERVER_URL
  );
}

// Reuse the server ID so existing sessions and workspace mappings stay intact.
const connections = new WeakMap<
  ServersService,
  ReturnType<ServersService['addOrGetServerByBaseUrl']>
>();

export async function connectMagicNotesServer(serversService: ServersService) {
  const existing = findMagicNotesServer(serversService);
  if (existing) return existing;

  let connection = connections.get(serversService);
  if (!connection) {
    connection = serversService.addOrGetServerByBaseUrl(MAGICNOTES_SERVER_URL);
    connections.set(serversService, connection);
  }
  try {
    return await connection;
  } finally {
    if (connections.get(serversService) === connection) {
      connections.delete(serversService);
    }
  }
}
